// Central public-site configuration.

const env = (typeof process !== "undefined" && process.env) || {};

export const SITE = {
  brand: "CULMORA OS",
  tagline: "Professional AI Workspace",
  origin: "Designed for professional work. Built for a global audience.",
  promise: "Professional AI work, in one calm workspace.",
  contactEmail: env.REACT_APP_CONTACT_EMAIL || "contact@culmoraos.com",
  siteUrl: env.REACT_APP_SITE_URL || "https://culmoraos.com",
  appUrl: env.REACT_APP_APP_URL || "",
  xUrl: env.REACT_APP_X_URL || "https://x.com/Culmoraos",
  linkedinUrl:
    env.REACT_APP_LINKEDIN_URL ||
    "https://www.linkedin.com/company/culmoraos",
  earlyAccessApiUrl:
    env.REACT_APP_EARLY_ACCESS_API_URL ||
    "https://juxgixoopdxvzpvipwtl.supabase.co/functions/v1/early-access",
  turnstileSiteKey: env.REACT_APP_TURNSTILE_SITE_KEY || "",
  privacyVersion: env.REACT_APP_PRIVACY_VERSION || "2026-08-09",
};

export const isAppLinkConfigured = () => Boolean(SITE.appUrl);

export const isEarlyAccessConfigured = () => Boolean(SITE.earlyAccessApiUrl);
